<template>
    <LayoutWithContainer>
        <template slot="header" v-if="event">
            <ContentHeader
                :title="event.eventName"
                :sub-title="event.start.displayDate"
                :back-link="backLinkUrl"
                :back-link-title="backLinkTitle"
            >
                <template slot="actions">
                    <router-link
                        :to="{ name: 'create-conference-document', props: { event_id: id } }"
                        class="btn btn--primary"
                    >
                        Upload Document
                    </router-link>
                </template>
            </ContentHeader>
        </template>
        <div v-if="$wait.is('documents')" class="loading">
            <Spinner :height="40" :width="40"/>
        </div>
        <div v-else-if="event">
            <h2>Member Opportunities</h2>
            <ul class="grid grid--cards">
                <template v-if="event.documents && event.documents.length">
                    <li v-for="document in event.documents" class="col-md-6 col-lg-6 col-12">
                        <Card
                            :url="{ name: 'preview-conference-document', params: { document_id: document.id } }"
                            :img="document.member_logo"
                            :contain-img="true"
                            :title="document.name"
                            :subTitle="document.updatedAt ? document.updatedAt : null"
                        />
                    </li>
                </template>
                <template v-else>
                    <li class="grid__error col-12">
                        <span class="h2">No documents found</span>
                    </li>
                </template>
            </ul>
            <div class="create">
                <router-link :to="{name: 'create-conference-document', props: { event_id: id }}" class="btn btn--primary">
                    Upload Document
                </router-link>
            </div>
        </div>
        <div v-else class="error">
            <span class="h2">Unable to load documents.</span>
            <button class="btn btn--link" @click.prevent="getData">Retry</button>
        </div>
    </LayoutWithContainer>
</template>

<script>
import API from '@api';
import LayoutWithContainer from '@layouts/LayoutWithContainer';
import ContentHeader from '@components/Header/ContentHeader';
import Card from '@components/Card/Card';
import Spinner from '@components/Spinner';

export default {
    name: 'DocumentList',
    components: {
        ContentHeader,
        LayoutWithContainer,
        Card,
        Spinner,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            documents: [],
            error: false,
            event: null,
        }
    },
    created() {
        this.getData();
    },
    methods: {
        async getData() {
            this.$wait.start('documents');
            this.error = false;

            try {
                this.event = await API.getEventDocuments(this.id);
            } catch(e) {
                this.error = true;
            } finally {
                this.$wait.end('documents');
            }
        },
    },
    computed: {
        backLinkUrl() {
            if(this.event.insightCategory){
                return `/documents/category/${this.event.insightCategory.id}`;
            }

            return "/documents";
        },
        backLinkTitle() {
            if(this.event.insightCategory){
                return `Back to ${this.event.insightCategory.name}`;
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .header {
        display: flex;
        align-items: flex-end;
        gap: 1rem;
        margin-bottom: 3rem;

        h1 {
            margin-bottom: 0;
        }

        h3 {
            margin-bottom: 0.5rem;
            color: #747484;
        }
    }

    .create {
        display: flex;
        justify-content: center;
        margin-top: 5rem;
    }

    .card--document {
        padding: 2rem 2rem 2rem 1rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        &, * {
            color: #000000;
        }

        .card__content {
            padding: 0 2rem 0 1rem;
        }

        .card__title {
            margin-bottom: 0.5rem;
        }

        .card__logo {
            width: 16rem;
            max-height: 7.2rem;
            object-fit: contain;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 100%;
            }
        }

        .card__thumbnail {
            line-height: 0;
            display: block;
            max-width: 100%;
        }

        .card__date {
            font-size: 16px;
            letter-spacing: -0.07px;
            line-height: 22px;
        }

        .card__date, .card__filename {
            display: block;
            color: #747484;
        }

        .card__filename {
            font-size: 12px;
            line-height: 16px;
            margin-top: 0.5rem;
        }
    }

    .error,
    .loading {
        min-height: 20rem;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;
    }
</style>
